import { combineReducers } from 'redux';

import eventosEspeciais from './eventosEspeciais/reducer';

export default combineReducers({
	eventosEspeciais,
});
